import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateNote = createAction(ACTION.COMPLAINT_UPDATE_NOTE.REQUEST, params => ({params}));
export const clearUpdateNote = createAction(ACTION.COMPLAINT_UPDATE_NOTE_CLEAR, params => ({params}));
